import React, { useState } from "react"
import { IReplenishmentDto } from "../../../../types/replenishment/IReplenishmentDto"
import { round2Digits } from "../../../common/CommonHelper"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { IModalMessage } from "../../../../types/error/IModalMessage"
import { ModalPopUp } from "../../../common/element/ModalPopUp"
import { CommonInput } from "../../../common/element/fields/CommonInput"
import { CommonFileList } from "../../../common/element/fields/CommonFileList"
import Button from "@/ui/components/Button"
import { ModalConfirm } from "@/components/common/element/ModalConfirm"

export const PaymentCheckTab: React.FC<{
  replenishment: IReplenishmentDto
  setReplenishment: (r: IReplenishmentDto) => void
}> = ({ replenishment, setReplenishment }) => {
  const [message, setMessage] = useState<IModalMessage | null>(null)
  const [modalConfirm, setModalConfirm] = useState<IModalMessage>()
  const [amount, setAmount] = useState<string | undefined>(
    round2Digits(Number(replenishment.rubAmountAfter) / 100).toString()
  )
  const [isAccepting, setIsAccepting] = useState(false)
  const [isCanceling, setIsCanceling] = useState(false)

  const acceptPaymentOrder = () => {
    if (Number(amount) < 0) {
      setMessage({ title: "Ошибка!", text: "Сумма не может быть меньше нуля" })
      return
    }

    setIsAccepting(true)

    TrinityAPI.acceptPayment(
      Number(replenishment.id),
      Math.round(Number(amount?.toString().replaceAll(" ", "")) * 100),
      response => {
        if (response.status === 200) {
          window.location.reload()
        } else {
          setMessage({ title: "Ошибка", text: `Ошибка подтверждения оплаты: ${response.data.message}` })
        }
      },
      () => setIsAccepting(false)
    )
  }

  const cancelPaymentOrder = () => {
    setIsCanceling(true)

    TrinityAPI.cancelPayment(
      Number(replenishment.id),
      response => {
        if (response.status === 200) {
          window.location.reload()
        } else {
          setMessage({ title: "Ошибка", text: `Ошибка отказа оплаты: ${response.data.message}` })
        }
      },
      () => setIsCanceling(false)
    )
  }

  const confirmCancel = (val: any) => {
    if (val) {
      cancelPaymentOrder()
    }
  }

  return (
    <>
      <ModalConfirm message={modalConfirm} setMessage={setModalConfirm} />
      <ModalPopUp message={message} close={() => setMessage(null)} />
      <div className="container">
        <div className="container-pop-up">
          <ul className="form-left">
            <li className="form-block-popup">
              <h4 className="heading-chapter">Информация об оплате</h4>
              {replenishment.status !== "BILL_PAID" &&
              replenishment.status !== "CR_FIX" &&
              replenishment.status !== "DONE" ? (
                <p className="message-course-yes">
                  Клиент еще не оплатил счет. Вы сможете продолжить, когда клиент загрузит платежное поручение
                </p>
              ) : (
                <>
                  <p className="message-course-yes">
                    {replenishment.status === "CR_FIX" || replenishment.status === "DONE"
                      ? "Оплата подтверждена"
                      : "Клиент оплатил счет и загрузил платежное поручение. Проверьте документы и\n" +
                        "                          нажмите\n" +
                        "                          кнопку\n" +
                        '                          "Подтвердить" если платеж прошел успешно'}
                  </p>
                  <div className="flex-row-10">
                    <CommonInput
                      disabled={replenishment.status === "DONE"}
                      typeName={"number"}
                      label={"Сумма"}
                      placeholder={""}
                      name={"amount"}
                      value={amount}
                      errorModel={undefined}
                      _callback={v => setAmount(v)}
                    />
                    <fieldset className="fieldset-200">
                      <legend>Валюта</legend>
                      <p className="text-form">RUB</p>
                    </fieldset>
                  </div>
                  <CommonFileList downloadableFiles={replenishment.paymentOrderFiles} />
                </>
              )}
            </li>
            {(replenishment.status === "BILL_PAID" || replenishment.status === "CR_FIX") && (
              <div className="flex-row-10">
                <Button onClick={acceptPaymentOrder} loading={isAccepting}>
                  {replenishment.status === "BILL_PAID" ? "Подтвердить" : "Изменить сумму"}
                </Button>
                {replenishment.status === "BILL_PAID" && (
                  <Button
                    variant="black"
                    onClick={() =>
                      setModalConfirm({
                        title: "Отказать в пополнении?",
                        text: "Вы действительно желаете отказать в пополнении?",
                        callbackValue: true,
                        _callback: confirmCancel
                      })
                    }
                    loading={isCanceling}
                  >
                    Отказ в пополнении
                  </Button>
                )}
                {/*<button className="btn grey-btn">Претензия</button>*/}
              </div>
            )}
          </ul>
        </div>
      </div>
    </>
  )
}
